// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-VoxelInspector {
  width: 300px;
  pointer-events: all;
}

.cesium-VoxelInspector div,
.cesium-VoxelInspector input[type="range"] {
  width: 100%;
  box-sizing: border-box;
}

.cesium-VoxelInspector .cesium-cesiumInspector-section {
  margin-top: 3px;
}

.cesium-VoxelInspector
  .cesium-cesiumInspector-sectionHeader
  + .cesium-cesiumInspector-show {
  border-top: 1px solid white;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/VoxelInspector/VoxelInspector.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,2BAA2B;AAC7B","sourcesContent":[".cesium-VoxelInspector {\n  width: 300px;\n  pointer-events: all;\n}\n\n.cesium-VoxelInspector div,\n.cesium-VoxelInspector input[type=\"range\"] {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.cesium-VoxelInspector .cesium-cesiumInspector-section {\n  margin-top: 3px;\n}\n\n.cesium-VoxelInspector\n  .cesium-cesiumInspector-sectionHeader\n  + .cesium-cesiumInspector-show {\n  border-top: 1px solid white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
